<template>
  <div class="statistics-member" v-loading="loading" style="min-height: 400px;">
    <div class="common-form">广告点击统计</div>
    <div class="d-s-stretch bd-box">
      <div class="d-s-c d-c left-box">

         <!--汇总-->
         <Total v-if="!loading"></Total>

        <!--新增会员-->
        
      </div>
      
    </div>
    <List v-if="!loading"></List>
    

  </div>
</template>

<script>
import StatisticsApi from '@/api/statistics.js';
import Total from './part/Total.vue';
import List from './part/List.vue'
export default {
  components: {
    Total,
    List
  },
  data(){
    return{
      /*是否正在加载*/
      loading:true,
      /*数据对象*/
      dataModel:{}
    }
  },
  provide: function () {
    return {
      dataModel: this.dataModel
    }
  },
  created() {

    this.getData();
  },
  methods:{

    /*获取数据*/
    getData() {
      let self = this;
      StatisticsApi.getBannerTotal({}, true)
        .then(res => {
          Object.assign(self.dataModel, res.data);
          self.loading = false;
        })
        .catch(error => {});
    }

  }
};
</script>

<style scoped="scoped">
  .statistics-member .bd-box{ border-top: 1px solid #EEEEEE;}
  .statistics-member .left-box{ width: 100%;}
</style>



// WEBPACK FOOTER //
// src/views/statistics/banner/index.vue